// extracted by mini-css-extract-plugin
module.exports = {"noDataContainer":"geofence-map_noDataContainer__1CKGF","mapContainer":"geofence-map_mapContainer__1nVzP","box":"geofence-map_box__PCNAC","title":"geofence-map_title__2zWLa"};